import { formatHourAndMinuteJP, roundNumberToFixed } from "@/utils/helper";
import { EMPTY_WORK_CHARACTER } from "@/constants";
const NUMBER_AFTER_DOT = 1;
export const FRAIL_CHART_KEYS = [
  "step",
  "kcal_total",
  "talk_time",
  "skin_day_avg",
  "sleep_time",
  "sithr",
];

const EMPTY_LABEL_TEXT = `${EMPTY_WORK_CHARACTER} `;

export const FRAIL_CHART = {
  step: {
    labels: [
      "歩数",
      function format(value) {
        const finalValue = value
          ? roundNumberToFixed(value, NUMBER_AFTER_DOT)
          : EMPTY_LABEL_TEXT;
        return `${finalValue}歩`;
      },
    ],
  },
  kcal_total: {
    labels: [
      "代謝量",
      function format(value) {
        const finalValue = value
          ? roundNumberToFixed(value, NUMBER_AFTER_DOT)
          : EMPTY_LABEL_TEXT;
        return `${finalValue}Kcal`;
      },
    ],
  },
  talk_time: {
    labels: [
      "会話量",
      function format(value) {
        const finalValue = value
          ? formatHourAndMinuteJP(value)
          : `${EMPTY_LABEL_TEXT}分`;
        return finalValue;
      },
    ],
  },
  skin_day_avg: {
    labels: [
      "平均皮膚温度",
      function format(value) {
        const finalValue = value
          ? roundNumberToFixed(value, NUMBER_AFTER_DOT)
          : EMPTY_LABEL_TEXT;
        return `${finalValue}°C`;
      },
    ],
  },
  sleep_time: {
    labels: [
      "睡眠時間",
      function format(value) {
        const finalValue = value
          ? formatHourAndMinuteJP(value)
          : `${EMPTY_LABEL_TEXT}分`;
        return finalValue;
      },
    ],
  },
  sithr: {
    labels: [
      "安静時脈拍数",
      function format(value) {
        const finalValue = value
          ? roundNumberToFixed(value, NUMBER_AFTER_DOT)
          : EMPTY_LABEL_TEXT;
        return `${finalValue}拍`;
      },
    ],
  },
};
